import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import HowItWorks from "@/components/landing/HowItWorks";
import BenefitsCalculator from "@/components/landing/BenefitsCalculator";
import ValueProposition from "@/components/landing/ValueProposition";
import Integrations from "@/components/landing/Integrations";
import Security from "@/components/landing/Security";
import DemoCase from "@/components/landing/DemoCase";
import AuditForm from "@/components/landing/AuditForm";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import CookieBanner from "@/components/CookieBanner";
import ChatWidget from "@/components/ChatWidget";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";

function Landing() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
      }
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <BenefitsCalculator />
        <ValueProposition />
        <Integrations />
        <Security />
        <DemoCase />
        <AuditForm />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

function PageViewTracker() {
  const location = useLocation();
  const firstLoad = useRef(true);
  useEffect(() => {
    // El primer PageView ya lo envía el snippet del píxel al cargar la página
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-platinum text-navy antialiased">
      <BrowserRouter>
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
        <CookieBanner />
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
